import { HorizontalLayout, VerticalLayout } from "../layout";
import ExpligoLogo from "../../assets/expligoL_cropped.png";

export default function ExpligoCard ({ style = {}, className = "", content, imageSize = "24px" }) {
  return (
    <VerticalLayout
      className={`expligo-card ${className}`}
      style={{
        width: "112px",
        height: "64px",
        borderRadius: "0.75rem",
        backgroundColor: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        padding: "0.5rem 0.75rem",
        justifyContent: "space-between",
        ...style,
      }}
    >
      <HorizontalLayout style={{ gap: "0.25rem", alignItems: "center" }}>
        <img
          src={ExpligoLogo}
          alt="Expligo Logo"
          style={{ width: imageSize, height: "100%", objectFit: "contain" }}
        />
      </HorizontalLayout>
      {!content ? <div
        style={{
          width: "32px",
          height: "4px",
          backgroundColor: "rgba(10,37,64,0.2)",
          borderRadius: "9999px",
        }}
      /> : (<>{content}</>)}
    </VerticalLayout>
  );
}
